<section class="card workflow-step__card">
  @if (!hideFormHeader) {
    <header class="workflow-step__card__header">
      <div class="u-fillRemaining">
        <h6 class="t-bold" data-test-id="attestationCardHeader">
          Attestations
        </h6>
      </div>
    </header>
  }

  <form class="workflow-step__card__body" #attestationForm="ngForm">
    @for (attestation of attestations; track attestation; let i = $index) {
      <section class="attestation">
        <header class="attestation__header">
          <h6 class="t-bold" data-test-id="'attestationHeaderText-' + i">
            {{ attestation.header }}
          </h6>
        </header>
        <section class="attestation__body">
          @for (section of attestation.sections; track section) {
            <div>
              <p
                class="t-data t-bold"
                [innerHTML]="section.header"
                data-test-id="'attestationSectionHeader-' + i"
              ></p>
              @for (paragraph of section.paragraphs; track paragraph) {
                <p
                  class="details"
                  [innerHTML]="paragraph"
                  data-test-id="'attestationParagraph-' + i"
                ></p>
              }
            </div>
          }
        </section>
        @if (!!attestation.confirmationText) {
          <footer class="attestation__footer" data-test-id="attestationFooter">
            <label
              class="form-control--checkbox__wrapper"
              data-test-id="attestationCheckboxWrapper"
            >
              @if (!checkBox?.checked) {
                <input
                  type="checkbox"
                  class="form-control form-control--checkbox"
                  required
                  ngModel
                  [name]="'attestation' + i"
                  #checkBox
                  (change)="updateValidity(attestationForm)"
                  data-test-id="'attestationCheckbox-' + i"
                />
              } @else {
                <i
                  class="icon icon--medium icon--primary"
                  data-test-id="attestationCheckboxIcon"
                  >checkbox_active</i
                >
              }
              <p
                class="t-data t-bold"
                [innerHTML]="attestation.confirmationText"
                data-test-id="attestationConfirmationText"
              ></p>
            </label>
          </footer>
        }
      </section>
    }
  </form>
</section>
